import { useSuspenseQuery } from '@tanstack/react-query';

import { getEditorialTeamValidationHistoryOptions } from '@/module/Author/EditorialTeam/Validation/model/EditorialTeamValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface EditorialTeamValidationHistoryProps {
  editorialTeamId: Id;
}

export function EditorialTeamValidationHistory({ editorialTeamId }: EditorialTeamValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getEditorialTeamValidationHistoryOptions(editorialTeamId));

  return <ValidationHistoryContent history={history} />;
}
